import clsx from 'clsx';
import MutedText from 'components/common/MutedText';
import { HubertButton } from 'components/HubertUI/HubertButton';
import NotificationsItem from 'components/Notifications/NotificationsItem';
import { RefreshCw } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNotifications } from '../notifications.context';

const NotificationsList = () => {
  const { t } = useTranslation('Notifications');
  const { notifications, isGetNotificationsBusy, refetchNotifications } = useNotifications();

  return (
    <div className="flex h-full flex-col justify-between gap-8">
      <div className="flex flex-row justify-between gap-8">
        <h1 className="text-xl font-bold">{t('list.heading')}</h1>
        <HubertButton
          variant={'outline'}
          size={'sm'}
          onClick={() => {
            refetchNotifications();
          }}
          loading={isGetNotificationsBusy}
          icon={<RefreshCw />}
        />
      </div>

      <div className="h-full overflow-auto">
        {/* {isGetNotificationsBusy ? (
          <FullViewLoading className='' title='Loading your notifications.' />
        ):( */}
        {notifications.length ? (
          <div className={clsx('flex h-full flex-col justify-start gap-4')}>
            {notifications.map((notification, idx) => {
              return <NotificationsItem key={`notification-${idx}`} notification={notification} />;
            })}
          </div>
        ) : (
          <div
            className={clsx(
              'flex-1',
              'justify-center',
              'hubert-vertical-center',
              'p-2',
              'rounded-md border border-gray-100 p-2',
            )}
          >
            <MutedText className="text-base">{t('list.empty')}</MutedText>
          </div>
        )}
        {/* )} */}
      </div>
    </div>
  );
};

export default NotificationsList;
